import React, { useEffect } from 'react';
import images from '../images';
import styles from '../css/Footer.module.scss'
import { DatoContacto } from './DatoContacto';
import { Titulo } from './Titulo';
export const Footer = () => {

    const datosContacto = [
        { logo: images.icons.telefono, dato: process.env.REACT_APP_TELEFONO },
        { logo: images.icons.whatsapp, dato: process.env.REACT_APP_WHATSAPP },
        { logo: images.icons.mail, dato: <><span className='d-block'>info@gasessanmartin.com.ar</span><span className='d-block'>gases.sanmartin@gmail.com</span></>, className: 'py-3 d-block' },
        { logo: images.icons.ubicacion, dato: <><span className='d-block'>Avenida Ricardo Balbín 1501 -</span><span className='d-block'>Ciudad de General San Martín</span><span className='d-block'>CP: 1650 - Prov. de Bs. As.</span></>, className: 'py-3 d-block' }
    ];

    return (
        <div id='contacto' className={styles.footer + ' px-5 text-white text-center pt-2'}>
            <Titulo texto={'CONTACTANOS'}/>
            <div className='container-fluid  border-bottom border-white pb-5 pt-2'>
                <div className='row align-items-center'>
                    <div className='col-6 text-start'>
                        {datosContacto.map(function (elem) {
                            return (
                                <DatoContacto dato={elem.dato} logo={elem.logo} className={'py-3 d-block mx-auto centrarContainer ' + styles.datoFooter} />
                            )
                        })}
                    </div>
                    <div className='col-6 text-center'>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62513.2948134132!2d-58.61920092653708!3d-34.567469813397096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb79e96ac80b9%3A0x6e1d5b65906d85a8!2sAv.%20101%20Dr.%20Ricardo%20Balb%C3%ADn%201501%2C%20B1672%20Villa%20Lynch%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses-419!2sar!4v1734836260861!5m2!1ses-419!2sar"
                            width="600" height="275" className={styles.mapa} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" />
                    </div>
                </div>
            </div>
            <p className='py-4 mb-0 text-center'><a href='https://new-age.com.ar/' className='text-decoration-none text-white'>Created by <span className='fw-bold'>NewAge</span></a></p>
        </div>
    )

}
